
    import { useContext, useEffect }  from 'react'
    import GlobalContext from 'proj/contexts/global';
    import ClassNames from 'classnames';

    import * as Content from './components';

    import Intro from './pages/intro';
    import Select from './pages/select';
    import Rank from './pages/rank';
    import Recommend from './pages/recommend';

    const moduleRegistry = 
    {
        Recommend,
        Select,
        Intro,
        Rank,
    }

    export default ( { ...props } ) =>
    {
        const { data, active, setActive, menuOpen, setMenuOpen  } = useContext(GlobalContext);
        const { logo, endpoints, startQuiz, url } = data || {};

        const onStartClick = e =>
        {
            setActive(0);
            setMenuOpen(false);
        }

        const getPage = () => 
        {
            switch(active)
            {
                case undefined: case null:
                    return <Intro />

                default :
                    const { module } = data?.sections[active];
                    const ModuleType = moduleRegistry[module?.type];
                    return ModuleType && <ModuleType key={ `active-${active}` } />
            }
        }

        const getMenu = () => endpoints &&
            <Content.MenuContainer>
                
                <Content.MenuWrapper>
                    <Content.CloseBtn onClick={ () => { setMenuOpen(false); } } />

                    <Content.MenuContent>
                        
                        { 
                            endpoints.map((val, idx) => val.id !== "uncategorized" &&
                                <Content.MenuItem
                                    href={ `${DOMAIN}${val.url || url}` }
                                    key={ `menu-item-${val.id}` }
                                    className={ val.id }
                                    text={ val.title }
                                    idx={ idx }
                                />)
                        }

                        <Content.MenuStart>
                            <Content.Button>
                                <Content.ButtonArrowIcon />
                                <Content.ButtonLabel text={ startQuiz } onClick={ onStartClick } />
                            </Content.Button>
                        </Content.MenuStart>

                    </Content.MenuContent>
                </Content.MenuWrapper>
            </Content.MenuContainer>

        useEffect(() =>
        {
            document.body.classList[menuOpen ? 'add' : 'remove']('menuOpen');
        }, [menuOpen])

        return  <Content.Container className={ ClassNames({ menuOpen }) }>
                    <Content.Content>
                        { logo && <Content.Logo src={ logo.value?.src } /> }
                        { getPage() }
                    </Content.Content>
                    { getMenu() }
                </Content.Container>
    }